import React from "react";
import "./styles/ContactPage.css";
const ContactPage = () => {
  return (
    <div className="contact-page_wrapper">
      <div className="contact-page">
        <h1>Contact Us</h1>

        <div className="contact-content">
          {/* Contact Form */}
          <form className="contact-form">
            <input placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input placeholder="Subject" required />
            <textarea placeholder="Message" rows="5" required></textarea>
            <button type="submit">Send Message</button>
          </form>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;
